/* import __COLOCATED_TEMPLATE__ from './radio-button.hbs'; */
import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './radio-button.module.scss';

@classic
@classNames(styles.component)
export default class PracticeWebsiteEditMenuRadioButton extends Component {}
